export const GLOBAL_FILTER_ARRAY_UPDATE = 'PageHeader/global-filter-array-update';
export const GLOBAL_FILTER_ARRAYS_UPDATE = 'PageHeader/global-filter-arrays-update';
export const GLOBAL_FILTER_CLEAR = 'PageHeader/global-filter-clear';
export const GLOBAL_FILTER_FOR_TYPE_CLEAR = 'PageHeader/global-filter-for-type-clear';
export const GLOBAL_FILTER_ITEM_REMOVE = 'PageHeader/global-filter-item-remove';
export const GLOBAL_FILTER_WEEKS_UPDATE = 'PageHeader/global-filter-weeks-update';
export const GLOBAL_FILTER_BRAND_UPDATE = 'PageHeader/global-filter-brand-update';
